import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { basePath } from './Config';

const PrivateRoutes = ({ component: Component, roles, ...rest }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const user = localStorage.getItem('user');
  
    if (!user) {
      navigate(`${basePath}login`)
    }
  }, [navigate, rest.path, roles]);

  return (
    <Component />
  );
};

export default PrivateRoutes;
